import type { Example } from "../examples";

const GROUPS: [Example["group"], string][] = [
  ["technique", "Techniques"],
  ["incident", "Incident-inspired"],
  ["baseline", "Baselines"],
];

/** Loads an example into the editor; it never runs it (ADR-0020). */
export function ExamplePicker({
  examples,
  selected,
  onSelect,
}: {
  examples: readonly Example[];
  selected: string;
  onSelect: (example: Example) => void;
}) {
  return (
    <label className="flex items-center gap-2 text-fg-dark">
      <span className="text-xs">Example</span>
      <select
        data-testid="example-picker"
        value={selected}
        onChange={(event) => {
          const example = examples.find((e) => e.id === event.target.value);
          if (example) onSelect(example);
        }}
        className="rounded border border-border bg-bg px-2 py-1 text-fg focus-visible:outline-2 focus-visible:outline-blue"
      >
        {GROUPS.map(([group, label]) => {
          const items = examples.filter((e) => e.group === group);
          return items.length === 0 ? null : (
            <optgroup key={group} label={label}>
              {items.map((e) => (
                <option key={e.id} value={e.id} title={e.summary}>
                  {e.title}
                </option>
              ))}
            </optgroup>
          );
        })}
      </select>
    </label>
  );
}
